import React, { useEffect, useState } from "react"
import { Container, Table } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import { Row, Form } from "reactstrap"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import configure from "configure"
import Swal from "sweetalert2"
import { fetchData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"

const CustomerContact = ({ stageData }) => {
    const [fixButtons, setFixButtons] = useState(false)
    const navigate = useNavigate()

    document.title = "Add Contact | Zithas Crm"

    document.addEventListener("scroll", () => {
        if (window.scrollY > 160) {
            setFixButtons(true)
        } else {
            setFixButtons(false)
        }
    })
    const params = useParams()

    const [profile, setProfile] = useState("")
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [position, setPosition] = useState("")
    const [email, setEmail] = useState("")
    const [dob, setDoB] = useState("")
    const [aniversary_date, setAniversaryDate] = useState("")
    const [login, setLogin] = useState("no")
    const [primary_contact, setPrimaryContact] = useState(true)
    const [password, setPassword] = useState("")
    const [per_proposal, setPerProposal] = useState("0")
    const [per_contract, setPerContract] = useState("0")
    const [per_signature, setPerSignature] = useState("0")
    const [per_support, setPerSuport] = useState("0")
    const [per_project, setPerProject] = useState("0")

    const [not_proposal, setNotProposal] = useState("0")
    const [note_contract, setNoteContract] = useState("0")
    const [note_signature, setNoteSignature] = useState("0")
    const [note_support, setNoteSuport] = useState("0")
    const [note_project, setNoteProject] = useState("0")
    const [isLoading, setLoading] = useState(false)

    const onAddContact = async e => {

        const onAddData = async () => {
            let primarycontact
            if (primary_contact == true) {
                primarycontact = "on"
            } else {
                primarycontact = "off"
            }
            const notification = [
                not_proposal,
                note_contract,
                note_signature,
                note_support,
                note_project,
            ]
            setLoading(true)
            const formData = new FormData()
            formData.append("customer_id", stageData?.customer_id)
            formData.append("profile", profile)
            formData.append("name", name)
            formData.append("phone", phone)
            formData.append("position", position)
            formData.append("email", email)
            formData.append("birthdate", dob)
            formData.append("anniversary_date", aniversary_date)
            formData.append("login", login)
            formData.append("primarycontact", primarycontact)
            formData.append("password", password)
            formData.append("proposal", per_proposal)
            formData.append("contract", per_contract)
            formData.append("contact_signature", per_signature)
            formData.append("support", per_support)
            formData.append("project", per_contract)
            formData.append("notification", JSON.stringify(notification))
            try {
                const response = await axios({
                    method: "post",
                    url: `${configure.apiUrl}/add_contact`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }).then(res => {
                    setLoading(false)
                    swal({
                        icon: "success",
                        text: "Contact Added Succesfully",
                    })
                })
            } catch (error) {
                console.log(error)
                setLoading(false)
            }
        }

        e.preventDefault()
        if (stageData?.stage >= 3) {
            Swal.fire({
                icon: 'warning',
                title: "Are You sure?",
                text: "Again you want to add New Contact as you have already saved & moved to next step?",
                showCancelButton: true,
                confirmButtonText: 'Yes, Create it!',
                cancelButtonText: 'No, cancel!',
            }).then((isOkay) => {
                if (isOkay?.isConfirmed) {
                    onAddData()
                }
            })
        } else {
            onAddData()
        }

    }

    const token = secureLocalStorage.getItem('auth_token')
    const [isEmpty , setIsEmpty] = useState(false)
    useEffect(() => {
        const getContactDetails = async () => {
            const formEntires = {
                customer_id: stageData?.customer_id
            }
            const res = await FetchPostData(setLoading, 'contacts', token, formEntires);
            if (res?.data?.success) {
                const details = res?.data?.data?.contacts[0] || {}
                setIsEmpty(res?.data?.data?.contacts?.length == 0)
                setName(details?.name)
                setPhone(details?.phone)
                setPosition(details?.position)
                setEmail(details?.email)
                setDoB(details?.birthdate)
                setAniversaryDate(details?.anniversary_date)
            }
        }
        if (stageData?.stage >= 3) {
            getContactDetails()
        }
    }, [stageData])

    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <form onSubmit={onAddContact}>
                <Row className="p-0">
                    <div className="col-md-6 pe-md-4">
                        <Row className="bg-white px-2 py-4 shadow mb-3">
                            <Row className="pe-0">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="">
                                        Profile Image
                                    </label>
                                    <input
                                        type="file"
                                        placeholder="Enter Name"
                                        className="form-control "
                                        onChange={e => setProfile(e.target.files[0])}
                                    />
                                </div>
                                <div className="col-md-6 text-end">
                                    <button className=" btn ms-md-2 btn-purple" disabled={stageData?.stage >= 3 && !isEmpty}>
                                        <i className="fas fa-save me-1"></i> save
                                    </button>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="">
                                        Name <span className="text-danger">*</span>{" "}
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Name"
                                        className="form-control "
                                        required
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3 pe-md-0">
                                    <label htmlFor="">Phone </label>
                                    <input
                                        type="number"
                                        placeholder="Enter Phone no."
                                        className="form-control "
                                        value={phone}
                                        onChange={e => setPhone(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="">
                                        Position <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Position"
                                        className="form-control "
                                        required
                                        value={position}
                                        onChange={e => setPosition(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3 pe-md-0">
                                    <label htmlFor="">
                                        Email <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        placeholder="Enter Email"
                                        className="form-control "
                                        required
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="">
                                        Birth Date
                                        {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control "
                                        value={dob}
                                        onChange={e => setDoB(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 mb-3 pe-md-0">
                                    <label htmlFor="">Anniversary Date</label>
                                    <input
                                        type="date"
                                        className="form-control "
                                        value={aniversary_date}
                                        onChange={e => setAniversaryDate(e.target.value)}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </div>

                    <div className="col-md-6 ps-md-4">
                        <Row className="bg-white px-3 align-items-start pt-4 shadow mb-3">
                            <p className="ps-0 pb-0 text-danger">
                                {
                                    "[Make sure to set appropriate permissions for this contact]"
                                }
                            </p>
                            <Table className="table-bordered">
                                <thead>
                                    <tr>
                                        <th className="col-6" colSpan={2}>
                                            Permission
                                        </th>
                                        <th className="col-6" colSpan={2}>
                                            Email Notifications
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>Proposal</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizemd"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setPerProposal("1")
                                                        } else {
                                                            setPerProposal("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>Proposal</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setNotProposal("1")
                                                        } else {
                                                            setNotProposal("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Contract</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizemd"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setPerContract("1")
                                                        } else {
                                                            setPerContract("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>Contract</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setNoteContract("1")
                                                        } else {
                                                            setNoteContract("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Contact Signature</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizemd"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setPerSignature("1")
                                                        } else {
                                                            setPerSignature("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>Contact Signature</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setNoteSignature("1")
                                                        } else {
                                                            setNoteSignature("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Support</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizemd"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setPerSuport("1")
                                                        } else {
                                                            setPerSuport("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>Support</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setNoteSuport("1")
                                                        } else {
                                                            setNoteSuport("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Project</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizemd"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setPerProject("1")
                                                        } else {
                                                            setPerProject("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                        <td>Project</td>
                                        <td>
                                            <div className="form-switch form-switch-md ms-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={e => {
                                                        if (e.target.checked) {
                                                            setNoteProject("1")
                                                        } else {
                                                            setNoteProject("0")
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Row>
                    </div>
                </Row>
            </form>
        </React.Fragment>
    )
}

export default CustomerContact
